import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../utils/colors.mjs';
import { switchStyle, switchVariants, switchActiveBackground, switchThumbStyle } from './switch.vanilla.mjs';

const SwitchImpl = forwardRef(
  ({
    className: classNameFromProps,
    color,
    size,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      switchStyle,
      switchVariants({ size }),
      classNameFromProps
    );
    const style = Object.assign(
      {},
      assignInlineVars({
        [switchActiveBackground]: color !== void 0 ? getColor(color) : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      SwitchPrimitive.Root,
      {
        "data-scope": "switch",
        "data-part": "root",
        className,
        style,
        ref: forwardedRef,
        ...props,
        children: /* @__PURE__ */ jsx(
          SwitchPrimitive.Thumb,
          {
            "data-scope": "switch",
            "data-part": "thumb",
            className: switchThumbStyle({ size })
          }
        )
      }
    );
  }
);
SwitchImpl.displayName = "Switch";
const Switch = styled(SwitchImpl);
Switch.toString = () => '[data-scope="switch"][data-part="root"]';

export { Switch };
//# sourceMappingURL=Switch.mjs.map
